import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type FormCompletion = {
  agreementAccepted: boolean;
  bankForm: boolean;
  businessOwnerForm: boolean;
  cashPayForm: boolean;
  cashPayAgreementAccepted: boolean;
  companyInfoForm: boolean;
  customerServiceForm: boolean;
  gatewayEnabled: boolean;
  storeDetailsForm: boolean;
  storeForm: boolean;
};

export const initialState = {
  agreementAccepted: false,
  bankForm: false,
  businessOwnerForm: false,
  cashPayForm: false,
  cashPayAgreementAccepted: false,
  companyInfoForm: false,
  customerServiceForm: false,
  gatewayEnabled: false,
  storeDetailsForm: false,
  storeForm: false,
};

export const formCompletionSlice = createSlice({
  name: "formCompletion",
  initialState,
  reducers: {
    setFormCompletion: (_, action: PayloadAction<FormCompletion>) =>
      action.payload,
  },
});
